import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  showSnackbar(
    message: string,
    bgColor: string,
    autoclose = false,
    showCloseButton = true,
    actionCallback?: () => void,
    actionLabel: string = 'OK'
  ): void {
    const config: any = {
      panelClass: ['mat-toolbar', bgColor],
    };

    if (autoclose) {
      config.duration = 3000;
    }

    let action = '';
    if (showCloseButton && !actionCallback) {
      action = 'X';
    } else if (actionCallback) {
      action = actionLabel;
    }

    const snackRef = this.snackBar.open(message, action, config);

    if (actionCallback) {
      snackRef.onAction().subscribe(() => actionCallback());
    }
  }
}
